<template>
  <div>

    <book-info-modal ref="bookInfoModal" :bookDto="bookDtoData" :bookCovers="bookCoversObj"></book-info-modal>

    <b-container>
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-btn block href="#" v-b-toggle.accordion variant="info">Στοιχεία εκδότη</b-btn>
        </b-card-header>
        <b-collapse id="accordion" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <small>
              <table class="table table-sm">
                <tbody>
                <tr>
                  <td class="fit">
                    <li><b><i>Όνομα:</i></b></li>
                  </td>
                  <td>{{publisherDto.publisherName}}</td>
                  <td class="fit">
                    <li><b><i>Διεύθυνση:</i></b></li>
                  </td>
                  <td>{{publisherDto.publisherAddress}}</td>
                </tr>
                <tr>
                  <td class="fit">
                    <li><b><i>Τηλέφωνο:</i></b></li>
                  </td>
                  <td>{{publisherDto.publisherPhone}}</td>
                  <td class="fit">
                    <li><b><i>Πόλη:</i></b></li>
                  </td>
                  <td>{{publisherDto.cityName}}</td>
                </tr>
                <tr>
                  <td class="fit">
                    <li><b><i>Email:</i></b></li>
                  </td>
                  <td>{{publisherDto.publisherEmail}}</td>
                  <td class="fit">
                    <li><b><i>T.K.:</i></b></li>
                  </td>
                  <td>{{publisherDto.publisherZipCode}}</td>
                </tr>
                </tbody>
              </table>
            </small>
          </b-card-body>
        </b-collapse>
      </b-card>
    </b-container>
    <hr />
    <b-container fluid>
      <div v-if="true">
        <small>
          <b-table head-variant="light"
                   small
                   bordered
                   hover
                   ref="table"
                   :items="tableMap"
                   :fields="fields">

            <template slot="bookTitle" slot-scope="data">
              <a href="#" @click="getBook(data.item.bookId)">
                {{data.item.bookTitle}}
              </a>
            </template>

          </b-table>
        </small>
      </div>
    </b-container>
  </div>
</template>

<script>

  import requests, {GlobalEudoxusBus} from "../../js/DistributionRequestService";
  import BookInfoModal from '../BookDeliveryTabComponents/BookInfoModalComponent';

  export default {
    name: "publisher-list-component",
    data() {
      return {
        bookDtoData: '',
        bookCoversObj: {},
        fields: [
          {key: 'bookId', label: 'Κωδικός', sortable: true, 'class': 'text-left'},
          {key: 'bookTitle', label: 'Βιβλία', sortable: true, 'class': 'text-left'},
          {key: 'total', label: 'Διαθέσιμα', sortable: true, 'class': 'text-right'},
          {key: 'delivered', label: 'Παραδόθηκαν', sortable: true, 'class': 'text-right'}
        ],
        tableMap: [],
        publisherDto: ''
      }
    },
    components: {
      'bookInfoModal': BookInfoModal
    },
    methods: {
      getBook(bookId) {
        requests.getBook(Number(bookId), this.bookInfoModal);
      },
      bookInfoModal(bookDto) {
        this.bookDtoData = bookDto;
        let fullPath = "https://static.eudoxus.gr/books/";
        let coverPathImg = fullPath + this.bookDtoData.pathToCover;
        let backCoverPathImg = this.bookDtoData.pathToBackcover;
        this.bookCoversObj = {frontCover: coverPathImg, backCover: backCoverPathImg};

        GlobalEudoxusBus.$emit('toggleBookInfoModal', true);
      }
    },
    created() {
      GlobalEudoxusBus.$on('publisherBooksTableSetup', object => {
        this.tableMap = object.tableMap;
        this.publisherDto = object.publisherDto;
      });
    }
  }
</script>

<style scoped>
  .table td.fit {
    padding-left: 50px;
    white-space: nowrap;
    width: 1%;
  }
</style>



// WEBPACK FOOTER //
// src/components/PublisherComponents/PublisherListComponent.vue